import "../sass/videos.scss";

var videoData = [];
var videoCards = "";

(function mainScript() {
	"use strict";
	fetchVideos();
})();

function fetchVideos() {
	const url = "https://www.googleapis.com/youtube/v3/search";
	const params = {
		type: "video",
		part: "snippet",
		maxResults: 50,
		order: "date",
		channelId: "UCoP-5e9qwVtIm-98wHuTSGA",
		key: "AIzaSyDUFGcaoIXkxtzMyAXHrnaPldzzo3_k1Lo",
	};

	$(".loader").show();
	$.ajax({
		method: "GET",
		url: url,
		data: params,
		success: (res) => {
			// console.info(res);
			videoData = res.items;
			renderVideoCards();
			$(".loader").hide();
		},
		error: function (xhr, status, errorThrown) {
			console.log("Request Status: " + xhr.statusText);
			console.log("Status: " + status);
			console.log("Error: " + errorThrown);
		},
	});
}

function renderVideoCards() {
	videoCards = videoData.map(function (video, vidInd) {
		var descriptionText = video.snippet.description
			? video.snippet.description
			: "No description was found for the video...";
		return `
        <div class="col-lg-3">
            <div class="card">
			<img class="card-img-top video-thumbnail" src="${video.snippet.thumbnails.high.url}" alt="video image" onclick="window.open('https://www.youtube.com/watch?v=${video.id.videoId}')">
                <div class="card-body">
                    <h5 class="card-title">
                    ${video.snippet.title}
                    </h5>
                    <p class="card-text">
                    ${descriptionText}
                    </p>
                    <a href="https://www.youtube.com/watch?v=${video.id.videoId}" class="btn btn-purple" target="_blank">Watch</a>
                </div>
            </div>
        </div>
        `;
	});

	let videoContainer = $("#ether-cards-videos");
	videoContainer.html(videoCards.join(""));
}
